import axios from "@/libs/api.request.js";
import { IS_LOCAL } from "@/config";
import { sort_ASCII1 as sort_ASCII } from "@/libs/utils";

export const getEnv = () => {
  if (IS_LOCAL) {
    return "//h5test.hzwxbz999.cn";
  } else {
    switch (window.location.hostname) {
      case "wxhdtest.hzwxbz999.cn":
        return "//h5test.hzwxbz999.cn";
      case "wxhdpre.hzwxbz999.cn":
        return "//h5.hzwxbz999.cn";
      default:
        return "//h5.hzwxbz3.cn";
    }
  }
};

// 手机号登录发送验证码
export const smsCodeApi = (data) =>
  axios.request({
    url: `${getEnv()}/user/sms/code/only-verification`,
    data: {
      ...data,
    },
    method: "post",
    unHint: true,
  });

// 手机号验证码登录
export const telLoginApi = (data) =>
  axios.request({
    url: `${getEnv()}/activity/authorize/tel-code`,
    data: {
      ...data,
      sign: sort_ASCII(data),
    },
    method: "post",
  });

// 账号密码登录
export const accountLoginApi = (data) =>
  axios.request({
    url: `${getEnv()}/activity/authorize/username`,
    data: {
      ...data,
      sign: sort_ASCII(data),
    },
    method: "post",
  });

// 少歌活动页面信息（礼包、倒计时）
export const shaogeInfo = (data) =>
  axios.request({
    url: `${getEnv()}/shaoge/info`,
    data: {
      ...data,
      sign: sort_ASCII(data),
    },
    method: "post",
  });

// 少歌预约接口
export const shaogeReserve = (data) =>
  axios.request({
    url: `${getEnv()}/shaoge/reserve`,
    data: {
      ...data,
      sign: sort_ASCII(data),
    },
    method: "post",
  });

// 少歌获取礼包接口
export const shaogeReceive = (data) =>
  axios.request({
    url: `${getEnv()}/shaoge/receive`,
    data: {
      ...data,
      sign: sort_ASCII(data),
    },
    method: "post",
  });

// 少歌礼包记录接口
export const shaogeRecord = (data) =>
  axios.request({
    url: `${getEnv()}/shaoge/gift-record`,
    data: {
      ...data,
      sign: sort_ASCII(data),
    },
    method: "post",
  });

export const eventTrackExtra = (data) =>
  axios.request({
    url: `${getEnv()}/noncore/event-track/extra`,
    data,
    unHint: true,
  });

// 少歌正式版活动页面相关信息
export const shaogeActInfo = (data) =>
  axios.request({
    url: `${getEnv()}/shaoge/activity/info`,
    data: {
      ...data,
      sign: sort_ASCII(data),
    },
    method: "post",
  });

// 少歌获取可绑定角色
export const shaogeActRole = (data) =>
  axios.request({
    url: `${getEnv()}/shaoge/activity/role`,
    data: {
      ...data,
      sign: sort_ASCII(data),
    },
    method: "post",
  });

// 少歌绑定角色
export const shaogeActRoleBind = (data) =>
  axios.request({
    url: `${getEnv()}/shaoge/activity/role-bind`,
    data: {
      ...data,
      sign: sort_ASCII(data),
    },
    method: "post",
    unHint: true,
  });

// 少歌正式页面领取礼包接口
export const shaogeActRoleReceive = (data) =>
  axios.request({
    url: `${getEnv()}/shaoge/activity/gift-receive`,
    data: {
      ...data,
      sign: sort_ASCII(data),
    },
    method: "post",
  });

// 少歌正式的礼包记录
export const shaogeActRoleRecord = (data) =>
  axios.request({
    url: `${getEnv()}/shaoge/activity/gift-record`,
    data: {
      ...data,
      sign: sort_ASCII(data),
    },
    method: "post",
  });
